import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  dateField,
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

export const getIdentificationFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  selectField(
    {
      name: 'type',
      label: 'ID type',
      required: true,
      refTable: 'identifier_type',
    },
    referenceTables,
  ),
  textField({ name: 'number', label: 'Number', required: true }),
  selectField(
    {
      name: 'issue_country',
      label: 'Issue country',
      required: true,
      refTable: 'country_code',
    },
    referenceTables,
  ),
  dateField({ name: 'issue_date', label: 'Issue date' }),
  dateField({ name: 'expiry_date', label: 'Expiry date' }),
  selectField(
    { name: 'issued_by', label: 'Issued by', refTable: 'country_code' },
    referenceTables,
  ),
  textareaField({ name: 'comments', label: 'Comments' }),
];
